module.exports = __webpack_public_path__ + "static/img/company.291bb3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company.png
// module id = JWP8
// module chunks = 1